export default {
  credentials: [],
  loading: false
};
